import React from 'react';

const Banner: React.FC = () => (
  <div className="banner">
    <div className="banner-content">
      <h2 className="banner-title">☕ Promoción del mes ☕</h2>
      <p className="banner-subtitle">2x1 en cafés los viernes</p>
      <button className="banner-cta">Ver Promociones</button>
    </div>
  </div>
);

export default Banner;